import { AppState } from './state';
import { RouteRecordRaw } from 'vue-router';

export const getters = {
  // menus(state: AppState): RouteRecordRaw[] {
  //   return state.menus;
  // }
};
